import React, { Component } from 'react';
import PropTypes from 'prop-types';
import QuestionMark from 'components/QuestionMark';
import './styles.scss';

const propTypes = {
  className: PropTypes.string,
  header: PropTypes.string,
  questionMark: PropTypes.string
};
const defaultProps = {
  className: ''
};

class Section extends Component {
  renderSectionTitle() {
    const { header, questionMark } = this.props;
    return (
      <div className="component-section-header row">
        <div className="col-sm-12">
          <h2 className="component-section__title">
            {header}
            {questionMark && <QuestionMark content={questionMark} />}
          </h2>
        </div>
      </div>
    );
  }

  render() {
    const { children, className, header } = this.props;
    return (
      <div className={`component-section ${className}`}>
        {header && header.length > 0 ? this.renderSectionTitle() : ''}
        <div className="row component-section__content">{children}</div>
      </div>
    );
  }
}

Section.propTypes = propTypes;
Section.defaultProps = defaultProps;

export default Section;
